// src/components/services/ServicesHeader.jsx
import React from "react";

const ServicesHeader = () => {
  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 1.5rem",
  };

  const headerStyle = {
    background: "linear-gradient(to right, #000000, #0891b2)",
    color: "white",
    padding: "3rem 0",
    textAlign: "center",
  };

  const titleStyle = {
    fontSize: "2.5rem",
    fontWeight: "bold",
    margin: "0 0 1rem 0",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  };

  const subtitleStyle = {
    fontSize: "1.2rem",
    color: "#e0e0e0",
    margin: "0",
    paddingTop: "0.5rem",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  };

  return (
    <div style={headerStyle}>
      <div style={containerStyle}>
        <h1 style={titleStyle}>Book An Appointment!</h1>
        <p style={subtitleStyle}>
          Schedule your custom drilling, equipment maintenance, or consultation
          online.
        </p>
        <div style={subtitleStyle}>
          Call us directly at <strong>(647)-608-2860</strong> or message us on{" "}
          <a
            href="https://www.facebook.com/900BowlingProshop"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline", color: "#e0e0e0" }}
          >
            <strong>Facebook</strong>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ServicesHeader;
